import { useId } from "react";
import { FiMail } from "react-icons/fi";

type Props = {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  required?: boolean;
  autoFocus?: boolean;
};

export default function EmailField({
  label = "Email id",
  value,
  onChange,
  placeholder = "you@company.com",
  required = true,
  autoFocus = false,
}: Props) {
  const id = useId();
  return (
    <div>
      <label htmlFor={id} className="mb-1 block text-xs font-medium text-gray-700">
        {label}
      </label>
      <div className="relative">
        <FiMail className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          id={id}
          type="email"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          placeholder={placeholder}
          className="w-full rounded-xl border border-gray-300 bg-white px-9 py-2 text-sm text-gray-900 outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-500/20"
          autoComplete="email"
          autoFocus={autoFocus}
        />
      </div>
    </div>
  );
}
